// extracted by mini-css-extract-plugin
var _1 = "anuoIGDixT7ZNEwBnW0x";
var _2 = "ZXfkX2klhS27Y88DGtJz";
var _3 = "anuoIGDixT7ZNEwBnW0x";
var _4 = "ZXfkX2klhS27Y88DGtJz";
export { _1 as "adviser-control-label", _2 as "adviser-phone-number", _3 as "adviserControlLabel", _4 as "adviserPhoneNumber" }
